import React from 'react';
import { StyledNavIcon, StyledNavButton, StyledNavIconWrapper } from '../../styled/StyledNavButton';

interface INavItemProps {
  icon?: React.FunctionComponent<React.PropsWithChildren<unknown>>;
  name: string;
  extraLabel?: string;
  className?: string;
  /**
   * component props will be passed through
   */
  [key: string]: unknown;
}

const NavItem = ({ icon, name, extraLabel, className, ...otherProps }: INavItemProps) => (
  <StyledNavButton className={className} buttonType="tertiary" {...otherProps}>
    {icon && (
      <StyledNavIconWrapper>
        <StyledNavIcon as={icon} />
      </StyledNavIconWrapper>
    )}
    {name}
    {extraLabel && <span className="nav-item-extra-label">{extraLabel}</span>}
  </StyledNavButton>
);

export default NavItem;
